import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function PermissoesGridFilter() {
    const [filterIdGrupo, setfilterIdGrupo] = useState<FilterValuesProps>({
        property: 'idGrupoUsuario',
        operator: 'eq',
        value: null,
        idProperty: 'idGrupoUsuario',
    });

    const [dsGrupoUsuario, setdsGrupoUsuario] = useState<FilterValuesProps>({
        property: 'dsGrupoUsuario',
        operator: 'like',
        value: null,
        idProperty: 'dsGrupoUsuario',
    });

    const [dsObservacao, setdsObservacao] = useState<FilterValuesProps>({
        property: 'dsObservacao',
        operator: 'like',
        value: null,
        idProperty: 'dsObservacao',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterIdGrupo, setter: setfilterIdGrupo },
                { value: dsGrupoUsuario, setter: setdsGrupoUsuario },
                { value: dsObservacao, setter: setdsObservacao },
            ]}
        >
            <Grid sx={{ flex: 3 }}>
                <CissTextField
                    label="Código Grupo Usuário"
                    value={filterIdGrupo.value}
                    onChange={(e) => setfilterIdGrupo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Grupo Usuário"
                    value={dsGrupoUsuario.value}
                    onChange={(e) => setdsGrupoUsuario((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Observação"
                    value={dsObservacao.value}
                    onChange={(e) => setdsObservacao((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
